import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  overflow-x: auto;
  margin: 2rem auto 1rem auto;
  min-margin-left: 5rem;
  min-margin-right: 5rem;
  height: fit-content;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.8rem, calc(0.6rem + 0.4vw), 3rem);

  /* @media (max-width: 2880px) {
    max-width: 80rem;
  }

  @media (max-width: 1920px) {
    max-width: 60rem;
  }

  @media (max-width: 1440px) {
    max-width: 30rem;
  }

  @media (max-width: 720px) {
    max-width: 20rem;
  }

  @media (max-width: 480px) {
    max-width: 12rem;
  } */
`

export const GridContainer = styled.div<{rowCount:number, columnCount: number}>`
  grid-template-columns: repeat(${props => props.columnCount+1}, auto);
  display: grid;
  max-width: 55rem;

  input.normal:nth-of-type(1) {
      border-top-left-radius: 1rem;
  }
      
  input.normal:nth-of-type(${props => props.columnCount}) {
      border-top-right-radius: 1rem;
  }

  input.normal:nth-last-of-type(${props => props.columnCount}) {
      border-bottom-left-radius: 1rem;
  }
      
  input.normal:last-of-type {
      border-bottom-right-radius: 1rem;
  }

  .one00 {
    border-top-left-radius: 1rem;
  }

  .two0${props => props.columnCount-1}{
    border-top-right-radius: 1rem;
  }

  .one${props => props.rowCount-1}0{
      border-bottom-left-radius: 1rem;
  }

  .two${props => props.rowCount-1}${props => props.columnCount-1}{
      border-bottom-right-radius: 1rem;
  }

  .one {
    color: #266481;
  }

  .two {
    color: #BF383B;
  }
`

export const HorizontalHeader = styled.div`
  width: 8rem;
  padding-bottom: 0.4rem;
`

export const HalfHorizontalHeader = styled.div`
  width: 7rem;
  padding-bottom: 0.4rem;
`

export const EmptyHeader = styled.div`
  width: 1rem;
  padding-bottom: 0.4rem;
`

export const VerticalHeader = styled.div`
  width: 8rem;
  display: flex;
  align-items: center;
`

export const CellInput = styled.input`
  width: 9rem;
  height: 2.5rem;
  padding: 0.5rem;
  background-color: #F4F4F4;
  border: 0;
  font-size: clamp(0.6rem, calc(0.5rem + 0.5vw), 10rem);

  :focus {
    outline: 0;
    border: 1px solid #000;
  }
`

export const HalfInputsDiv = styled.div`
  display: flex;
`

export const HalfCellInput = styled.input`
  width: 4.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  background-color: #F4F4F4;
  border: 0;
  font-size: clamp(0.6rem, calc(0.5rem + 0.5vw), 10rem);

  :focus {
    outline: 0;
    border: 1px solid #000;
  }
`

// export const Table = styled.table`
//   font-family: 'Inter', sans-serif;
//   font-size: 1.0vw;
//   border-collapse: collapse;
//   width: max-content;
//   margin: 0 auto;
// `

// export const TableHead = styled.thead`
//   text-align: left;
// `

// export const TableBody = styled.tbody`
//   tr:nth-child(1) td:nth-child(2) {
//       border-top-left-radius: 0.8vw;
//   }
      
//   tr:nth-child(1) td:last-child {
//       border-top-right-radius: 0.8vw;
//   }

//   tr:last-child td:nth-child(2) {
//       border-bottom-left-radius: 0.8vw;
//   }
      
//   tr:last-child td:last-child {
//       border-bottom-right-radius: 0.8vw;
//   }
// `

// export const HorizontalHeaderRow = styled.tr`
//   height: 5vh;
// `

// export const HorizontalHeaderCell = styled.th`
//   font-weight: 400;
//   padding-left: 1vw;
// `

// export const VerticalHeaderCell = styled.th`
//   font-weight: 400;
//   text-align: left;
//   width: 10.5vw;
// `

// export const ItemRow = styled.tr`
//   height: 5vh;
  
//   .notLast{
//     border-bottom: #c4c4c4 solid 1px;
//   }
// `

// export const ItemCell = styled.td`
//   background-color: #F4F4F4;
//   width: 10.5vw;
//   padding-left: 1vw;
// `
